import type { SummaryItemDescriptor } from '../extras';
import type { RenewType } from '../types';

type TicketSummaryContext = {
  renewType?: RenewType;
  lineCount: number;
  dyjPlayed: boolean;
  numberOfDraws: number;
};

function getTicketSummaryItems({ renewType, lineCount, dyjPlayed, numberOfDraws }: TicketSummaryContext): SummaryItemDescriptor[] {
  const items: SummaryItemDescriptor[] = [];

  if (renewType === 'Weeks') {
    items.push({
      id: 'duration',
      translationKey: 'ticket_details.purchase_summary.total_duration',
      translationParams: { lines: lineCount, duration: numberOfDraws },
    });
  } else {
    items.push({
      id: 'duration-renewal',
      translationKey: 'ticket_details.purchase_summary.total_duration_renewal',
      translationParams: { lines: lineCount },
    });
  }

  if (dyjPlayed) {
    items.push({
      id: 'dyj',
      translationKey: 'tippengine.extras.options.double_jackpot.title',
    });
  }

  return items;
}

export { getTicketSummaryItems, type TicketSummaryContext };
